/* tslint:disable */
/* eslint-disable */
/**
 * Limber Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReassessmentWindow
 */
export interface ReassessmentWindow {
    /**
     * 
     * @type {Date}
     * @memberof ReassessmentWindow
     */
    start: Date;
    /**
     * 
     * @type {Date}
     * @memberof ReassessmentWindow
     */
    end: Date;
}

export function ReassessmentWindowFromJSON(json: any): ReassessmentWindow {
    return ReassessmentWindowFromJSONTyped(json, false);
}

export function ReassessmentWindowFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReassessmentWindow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'start': (new Date(json['start'])),
        'end': (new Date(json['end'])),
    };
}

export function ReassessmentWindowToJSON(value?: ReassessmentWindow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'start': (value.start.toISOString()),
        'end': (value.end.toISOString()),
    };
}


